export enum OrderQueryFetch {
  NONE,
  SIBLING_CHILDREN,
  FULL_STRATEGY,
}

export namespace OrderQueryFetch {
  let elements = [
    OrderQueryFetch.NONE,
    OrderQueryFetch.SIBLING_CHILDREN,
    OrderQueryFetch.FULL_STRATEGY,
  ];
  let alias = "com.bcdfx.api.servicerequest.reporting.OrderQueryFetch";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
